import ReactDOM from "react-dom";
// import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import Modal from 'react-modal';

Modal.setAppElement('#root');

ReactDOM.render( <App/>, document.getElementById('root'));

// this should work but it doesnt, idk why
// const container = document.getElementById('App');
// const root = createRoot(container!); //if you use TypeScript
// createRoot(container);
// root.render(<App/>);
